import debounce from '../principles/performance/debounce';

// Show-Hide Legal Disclaimer

$('.js-site-footer--legal__notes-trigger').click(function () {
  $('.site-footer--legal__notes').toggle(0, function () {
    $('html, body').animate({ scrollTop: $(document).height() }, 'fast');
  });
  $('.js-show-site-footer--legal__notes, .js-hide-site-footer--legal__notes').toggle();
});

// Show More/Show Less (Entire Footer)

(function() {
  var $footerShowMoreTrigger = $('.js-footer__show-more--trigger');
  var $siteFooterContainer = $('.site-footer__container');

  $footerShowMoreTrigger.on('click', function () {
    $footerShowMoreTrigger.text($(this).text() == 'Show Less' ? 'Show More' : 'Show Less');
    $('.site-footer__container').toggle();
  });

  var handleResize = function() {
   // resets to default/CSS breakpoint styles
   $siteFooterContainer.removeAttr('style');
   $footerShowMoreTrigger.text('Show More');
  };

  $(window).on('resize', debounce(handleResize, 250));
}());



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/components/footer-collapsible.js
 **/